import axios from 'axios';
import { ApiResponse } from '../types';

class ApiService {
  private api: any;

  constructor() {
    this.api = axios.create({
      baseURL: process.env.REACT_APP_BFF_URL || 'http://localhost:8080',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Interceptor para adicionar token de autorização
    this.api.interceptors.request.use((config: any) => {
      const token = sessionStorage.getItem('psd_token');
      
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });

    // Interceptor para tratamento de resposta
    this.api.interceptors.response.use(
      (response: any) => response,
      (error: any) => {
        const status = error.response?.status;
        const reqUrl: string | undefined = error.config?.url;

        // Evitar redirecionamento automático durante a chamada de login
        const isAuthLogin = reqUrl && (reqUrl.includes('/auth/login') || reqUrl.includes('/auth/validate'));

        if (status === 401 && !isAuthLogin) {
          // Token expirado ou inválido (não redirecionar quando for a rota de login/validate)
          sessionStorage.removeItem('psd_token');
          window.location.href = '/login';
        }

        return Promise.reject(error);
      }
    );
  }

  async get<T>(endpoint: string): Promise<ApiResponse<T>> {
    try {
      const response: any = await this.api.get(endpoint);
      return {
        data: response.data,
        status: response.status,
      };
    } catch (error: any) {
      return {
        error: error.response?.data?.error || error.response?.data?.message || error.message || 'Erro na requisição',
        status: error.response?.status || 500,
      };
    }
  }

  async post<T>(endpoint: string, data?: any): Promise<ApiResponse<T>> {
    try {
      const response: any = await this.api.post(endpoint, data);
      return {
        data: response.data,
        status: response.status,
      };
    } catch (error: any) {
      return {
        error: error.response?.data?.error || error.response?.data?.message || error.message || 'Erro na requisição',
        status: error.response?.status || 500,
      };
    }
  }

  async put<T>(endpoint: string, data?: any): Promise<ApiResponse<T>> {
    try {
      const response: any = await this.api.put(endpoint, data);
      return {
        data: response.data,
        status: response.status,
      };
    } catch (error: any) {
      return {
        error: error.response?.data?.error || error.response?.data?.message || error.message || 'Erro na requisição',
        status: error.response?.status || 500,
      };
    }
  }

  async delete<T>(endpoint: string, data?: any): Promise<ApiResponse<T>> {
    try {
      const response: any = await this.api.delete(endpoint, { data });
      return {
        data: response.data,
        status: response.status,
      };
    } catch (error: any) {
      return {
        error: error.response?.data?.error || error.response?.data?.message || error.message || 'Erro na requisição',
        status: error.response?.status || 500,
      };
    }
  }
}

const apiService = new ApiService();
export default apiService;